import { Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, tap } from 'rxjs/operators';

@Component({
    selector: 'app-uig-product-natural-rabatt-tab',
    templateUrl: './uig-product-natural-rabatt-tab.component.html',
    styleUrls: ['./uig-product-natural-rabatt-tab.component.scss'],
    standalone: false
})
export class UigProductNaturalRabattTabComponent {

  private mainMediaContainer = new BehaviorSubject(null);

  product$: Observable<Product> = this.currentProductService
    .getProduct()
    .pipe(
      filter(Boolean),
      distinctUntilChanged(),
      tap((p: Product) => {
        this.mainMediaContainer.next(p.naturalRabatt?.product.images ? p.naturalRabatt?.product.images : {});
      })
    );

  image$ = combineLatest([this.product$, this.mainMediaContainer]).pipe(
    map(([, container]) => container)
  );

  constructor(private currentProductService: CurrentProductService) {}

}
